export interface DramaEpisode {
  num: number;
  title: string;
  url: string;
}

export interface Drama {
  slug: string;
  title: string;
  englishTitle: string;
  coverImage: string;
  bannerImage: string;
  category: string;
  categories: string[];
  year: number;
  region: string;
  rating: number;
  episodeCount: number;
  status: '更新中' | '已完结';
  updateInfo: string;
  description: string;
  director: string;
  cast: string[];
  tags: string[];
  episodes: DramaEpisode[];
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-grid-line' },
  { slug: 'guochan', name: '国产剧', icon: 'ri-building-2-line' },
  { slug: 'hanju', name: '韩剧', icon: 'ri-global-line' },
  { slug: 'meiju', name: '美剧', icon: 'ri-earth-line' },
  { slug: 'riju', name: '日剧', icon: 'ri-compass-3-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-movie-2-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-tv-line' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line' },
];

export const dramas: Drama[] = [
  {
    slug: 'qing-yu-nian-2',
    title: '庆余年 第二季',
    englishTitle: 'Joy of Life Season 2',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20with%20a%20scholar%20in%20traditional%20robes%20holding%20a%20fan%2C%20dramatic%20lighting%2C%20palace%20architecture%20in%20background%2C%20cinematic%20composition%2C%20warm%20golden%20tones%2C%20clean%20background%20with%20subtle%20texture&width=600&height=800&seq=drama-cover-01&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20scene%20with%20grand%20palace%20halls%2C%20ancient%20Chinese%20architecture%2C%20dramatic%20atmospheric%20lighting%2C%20warm%20golden%20and%20red%20color%20palette%2C%20cinematic%20wide%20shot%2C%20majestic%20and%20grandiose%2C%20clean%20composition&width=1600&height=700&seq=drama-banner-01&orientation=landscape',
    category: 'guochan',
    categories: ['guochan', 'all'],
    year: 2024,
    region: '中国大陆',
    rating: 8.5,
    episodeCount: 36,
    status: '已完结',
    updateInfo: '全36集',
    description: '范闲在经历了第一季的种种考验后，逐渐成长为一代英才。面对朝堂之上的明争暗斗和江湖之中的风起云涌，他以过人的智慧和勇气，在复杂的权谋漩涡中步步为营。与此同时，他也在探寻着自己身世的真相，一段跨越二十年的秘密即将浮出水面。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟', '田雨', '李小冉', '宋轶'],
    tags: ['古装', '权谋', '武侠', '改编', '热门'],
    episodes: Array.from({ length: 36 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/qing-yu-nian-2?ep=${i + 1}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'fan-hua',
    title: '繁花',
    englishTitle: 'Blossoms Shanghai',
    coverImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20drama%20poster%20with%20elegant%20man%20in%20vintage%20suit%2C%20neon%20lights%20of%20old%20Shanghai%20Bund%20in%20background%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20and%20amber%20tones%2C%20cinematic%20portrait%2C%20sophisticated%20and%20glamorous&width=600&height=800&seq=drama-cover-02&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20Bund%20at%20night%20with%20colorful%20neon%20signs%2C%20vintage%20cars%20on%20the%20street%2C%20bustling%20cityscape%2C%20nostalgic%20golden%20lighting%2C%20cinematic%20wide%20cityscape%20shot%2C%20warm%20tones&width=1600&height=700&seq=drama-banner-02&orientation=landscape',
    category: 'guochan',
    categories: ['guochan', 'all'],
    year: 2024,
    region: '中国大陆',
    rating: 8.7,
    episodeCount: 30,
    status: '已完结',
    updateInfo: '全30集',
    description: '以上世纪九十年代的上海为背景，讲述了阿宝从一个普通青年蜕变为商界传奇的故事。在改革开放的大潮中，他历经沉浮，见证了时代变迁下的人情冷暖与商海浮沉。王家卫导演的首部电视剧作品，画面精美，情感细腻。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '郑恺', '游本昌'],
    tags: ['年代', '商战', '爱情', '上海', '热门'],
    episodes: Array.from({ length: 30 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/fan-hua?ep=${i + 1}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'kuang-biao',
    title: '狂飙',
    englishTitle: 'The Knockout',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20intense%20police%20officer%20and%20gangster%20face%20to%20face%2C%20dark%20moody%20lighting%2C%20urban%20night%20setting%2C%20dramatic%20cinematic%20composition%2C%20strong%20contrast%2C%20neutral%20background&width=600&height=800&seq=drama-cover-03&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Gritty%20Chinese%20urban%20crime%20drama%20scene%20with%20police%20squad%20cars%20on%20rainy%20city%20streets%20at%20night%2C%20neon%20reflections%20on%20wet%20pavement%2C%20tense%20atmosphere%2C%20dark%20moody%20cinematography%2C%20wide%20shot&width=1600&height=700&seq=drama-banner-03&orientation=landscape',
    category: 'guochan',
    categories: ['guochan', 'all'],
    year: 2023,
    region: '中国大陆',
    rating: 8.8,
    episodeCount: 39,
    status: '已完结',
    updateInfo: '全39集',
    description: '以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开的长达二十年的生死较量。剧集通过群像叙事，展现了扫黑除恶过程中的惊心动魄与复杂人性，是一部震撼人心的现实主义力作。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚', '倪大红'],
    tags: ['刑侦', '悬疑', '扫黑除恶', '现实主义', '热门'],
    episodes: Array.from({ length: 39 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/kuang-biao?ep=${i + 1}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'hei-se-rong-yao',
    title: '黑色荣耀',
    englishTitle: 'The Glory',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20elegant%20woman%20in%20dark%20sophisticated%20outfit%2C%20mysterious%20expression%2C%20minimalist%20composition%2C%20cool%20silver%20and%20deep%20green%20tones%2C%20refined%20and%20intense%20atmosphere%2C%20clean%20studio%20background&width=600&height=800&seq=drama-cover-04&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20drama%20scene%20with%20sophisticated%20architecture%20interior%2C%20minimalist%20modern%20design%2C%20dramatic%20lighting%20through%20large%20windows%2C%20cold%20silver%20and%20emerald%20color%20palette%2C%20cinematic%20wide%20composition%2C%20mysterious%20atmosphere&width=1600&height=700&seq=drama-banner-04&orientation=landscape',
    category: 'hanju',
    categories: ['hanju', 'all'],
    year: 2023,
    region: '韩国',
    rating: 9.1,
    episodeCount: 8,
    status: '已完结',
    updateInfo: '全8集',
    description: '梦想成为建筑师的文东恩，在高中时期因校园暴力而被迫退学。多年后，加害者的孩子上了小学，东恩成为了那个孩子的班主任。一场精心策划的复仇大戏由此拉开序幕，向当年的施暴者和旁观者展开彻底而凄惨的报复。',
    director: '安吉镐',
    cast: ['宋慧乔', '李到晛', '林智妍', '廉惠兰', '朴成勋', '郑成日'],
    tags: ['复仇', '悬疑', '校园暴力', '韩剧', '热门'],
    episodes: Array.from({ length: 8 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/hei-se-rong-yao?ep=${i + 1}`,
    })),
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'san-ti',
    title: '三体',
    englishTitle: 'Three-Body',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20with%20mysterious%20cosmic%20elements%2C%20three%20suns%20in%20dark%20space%2C%20futuristic%20and%20philosophical%20atmosphere%2C%20deep%20navy%20and%20crimson%20color%20scheme%2C%20cinematic%20composition%2C%20dark%20minimalist%20background&width=600&height=800&seq=drama-cover-05&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20scene%20with%20vast%20cosmic%20space%2C%20distant%20galaxies%20and%20nebula%2C%20mysterious%20planets%2C%20deep%20space%20atmosphere%2C%20cinematic%20wide%20shot%2C%20dark%20and%20philosophical%20mood%2C%20rich%20deep%20colors&width=1600&height=700&seq=drama-banner-05&orientation=landscape',
    category: 'guochan',
    categories: ['guochan', 'all'],
    year: 2023,
    region: '中国大陆',
    rating: 8.1,
    episodeCount: 30,
    status: '已完结',
    updateInfo: '全30集',
    description: '改编自刘慈欣同名科幻小说。纳米科学家汪淼被警官史强带到联合作战中心，潜入神秘组织"科学边界"进行调查。在这个过程中，他接触到了一个名为"三体"的虚拟现实游戏，发现了地外文明的存在，以及人类文明面临的巨大危机。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健', '李小冉'],
    tags: ['科幻', '悬疑', '改编', '国产', '热门'],
    episodes: Array.from({ length: 30 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/san-ti?ep=${i + 1}`,
    })),
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    slug: 'cai-liao-qiang-wei',
    title: '财阀家的小儿子',
    englishTitle: 'Reborn Rich',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20young%20businessman%20in%20luxurious%20suit%2C%20modern%20corporate%20building%20in%20background%2C%20sophisticated%20and%20powerful%20atmosphere%2C%20warm%20golden%20and%20dark%20wood%20tones%2C%20cinematic%20portrait%2C%20clean%20elegant%20background&width=600&height=800&seq=drama-cover-06&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Luxurious%20Korean%20corporate%20boardroom%20with%20large%20wooden%20table%2C%20modern%20skyscraper%20view%20through%20floor%20to%20ceiling%20windows%2C%20golden%20sunset%20light%2C%20powerful%20executive%20atmosphere%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=drama-banner-06&orientation=landscape',
    category: 'hanju',
    categories: ['hanju', 'all'],
    year: 2022,
    region: '韩国',
    rating: 8.3,
    episodeCount: 16,
    status: '已完结',
    updateInfo: '全16集',
    description: '管理财阀总裁一家老板风险的秘书尹贤宇，被冤枉涉嫌侵吞资金而遭杀害。醒来后他发现自己重生为财阀家的小儿子陈道俊，为了找出杀害自己的凶手，他开始了向财阀家族的复仇计划。',
    director: '郑大允',
    cast: ['宋仲基', '李星民', '申贤彬', '赵汉哲', '金南熙'],
    tags: ['重生', '商战', '悬疑', '韩剧', '热门'],
    episodes: Array.from({ length: 16 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/cai-liao-qiang-wei?ep=${i + 1}`,
    })),
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    slug: 'yu-feng-xing',
    title: '与凤行',
    englishTitle: 'The Legend of Shen Li',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20poster%20with%20female%20warrior%20in%20flowing%20red%20robes%2C%20phoenix%20imagery%2C%20ethereal%20cloud%20background%2C%20mythical%20ancient%20Chinese%20aesthetic%2C%20dramatic%20cinematic%20composition%2C%20warm%20crimson%20and%20gold%20tones&width=600&height=800&seq=drama-cover-07&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythical%20landscape%20with%20floating%20mountains%20and%20waterfalls%2C%20ethereal%20clouds%2C%20golden%20phoenix%20flying%20across%20crimson%20sky%2C%20fantasy%20epic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20warm%20mythical%20tones&width=1600&height=700&seq=drama-banner-07&orientation=landscape',
    category: 'guochan',
    categories: ['guochan', 'all'],
    year: 2024,
    region: '中国大陆',
    rating: 7.8,
    episodeCount: 39,
    status: '已完结',
    updateInfo: '全39集',
    description: '灵界碧苍王沈璃为掌握自己的命运而逃婚，在凡间与行止神君相遇。两人从互相试探到携手共进，演绎了一段跨越神魔两界的传奇爱恋。磅礴的仙侠世界观与细腻的情感刻画相结合。',
    director: '邓科',
    cast: ['赵丽颖', '林更新', '辛云来', '何与', '李嘉琦'],
    tags: ['仙侠', '古装', '爱情', '神话', '热门'],
    episodes: Array.from({ length: 39 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/yu-feng-xing?ep=${i + 1}`,
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    slug: 'xian-zai-wo-hei-hua',
    title: '现在拨打的电话',
    englishTitle: 'When the Phone Rings',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20drama%20poster%20with%20couple%20on%20phone%20call%2C%20warm%20romantic%20lighting%2C%20modern%20city%20night%20view%2C%20emotional%20and%20intimate%20atmosphere%2C%20soft%20warm%20beige%20and%20rose%20tones%2C%20cinematic%20composition&width=600&height=800&seq=drama-cover-08&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20city%20night%20scene%20with%20couple%20walking%20along%20city%20street%2C%20warm%20street%20lights%2C%20autumn%20leaves%2C%20romantic%20cinematic%20atmosphere%2C%20soft%20warm%20tones%2C%20wide%20shot%2C%20beautiful%20composition&width=1600&height=700&seq=drama-banner-08&orientation=landscape',
    category: 'hanju',
    categories: ['hanju', 'all'],
    year: 2024,
    region: '韩国',
    rating: 8.0,
    episodeCount: 12,
    status: '更新中',
    updateInfo: '更新至第8集',
    description: '一对政治联姻的夫妻，结婚三年从未有过真正的交流。某天妻子被绑架，绑匪要求丈夫打电话来。在这场危机中，两人开始重新认识彼此，一段始于谎言的婚姻逐渐演变为真正的爱情。',
    director: '朴尚宇',
    cast: ['柳演锡', '蔡秀彬', '许南俊', '张圭悧'],
    tags: ['爱情', '悬疑', '政治婚姻', '韩剧', '新剧'],
    episodes: Array.from({ length: 12 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/xian-zai-wo-hei-hua?ep=${i + 1}`,
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    slug: 'lian-yu-zhi',
    title: '恋人',
    englishTitle: 'My Dearest',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20historical%20drama%20poster%20with%20couple%20in%20traditional%20hanbok%2C%20romantic%20yet%20tragic%20atmosphere%2C%20joseon%20era%20setting%2C%20soft%20natural%20lighting%2C%20warm%20earth%20tones%2C%20cinematic%20portrait%20composition&width=600&height=800&seq=drama-cover-09&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Korean%20joseon%20era%20historical%20landscape%20with%20traditional%20hanok%20village%2C%20cherry%20blossom%20trees%2C%20soft%20spring%20lighting%2C%20romantic%20historical%20atmosphere%2C%20cinematic%20wide%20shot%2C%20warm%20film%20tones&width=1600&height=700&seq=drama-banner-09&orientation=landscape',
    category: 'hanju',
    categories: ['hanju', 'all'],
    year: 2023,
    region: '韩国',
    rating: 8.6,
    episodeCount: 21,
    status: '已完结',
    updateInfo: '全21集',
    description: '以朝鲜王朝时期的丙子胡乱为背景，讲述了一个神秘男子李清俊与贵族小姐刘吉彩之间历经战乱与分离的凄美爱情故事。时代动荡中，两个相爱的人在命运的洪流中不断错过与重逢。',
    director: '金成龙',
    cast: ['南宫珉', '安恩真', '李学周', '李多寅'],
    tags: ['古装', '爱情', '历史', '韩剧'],
    episodes: Array.from({ length: 21 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/lian-yu-zhi?ep=${i + 1}`,
    })),
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    slug: 'qing-luo-nian',
    title: '庆余年',
    englishTitle: 'Joy of Life',
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20young%20man%20in%20dark%20robes%2C%20mysterious%20smile%2C%20palace%20silhouette%2C%20dramatic%20lighting%2C%20warm%20amber%20and%20bronze%20tones%2C%20cinematic%20composition%2C%20clean%20background&width=600&height=800&seq=drama-cover-10&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20courtyard%20with%20traditional%20architecture%2C%20misty%20morning%20light%2C%20dramatic%20atmospheric%20mood%2C%20golden%20sunrise%2C%20majestic%20and%20mysterious%2C%20cinematic%20wide%20shot&width=1600&height=700&seq=drama-banner-10&orientation=landscape',
    category: 'guochan',
    categories: ['guochan', 'all'],
    year: 2019,
    region: '中国大陆',
    rating: 8.4,
    episodeCount: 46,
    status: '已完结',
    updateInfo: '全46集',
    description: '一个患有重症肌无力的现代青年，穿越到古代庆国成为一个婴儿。他拥有现代人的记忆和智慧，在复杂的宫廷斗争中凭借过人的头脑步步为营。权谋、武侠、科幻元素的完美融合，开创了古装剧新风格。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '辛芷蕾', '宋轶', '郭麒麟'],
    tags: ['古装', '权谋', '穿越', '武侠', '经典'],
    episodes: Array.from({ length: 46 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/qing-luo-nian?ep=${i + 1}`,
    })),
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
  {
    slug: 'gu-dou',
    title: '孤舟',
    englishTitle: 'Lonely Boat',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20spy%20thriller%20drama%20poster%2C%20man%20in%201940s%20trench%20coat%2C%20rainy%20street%20of%20old%20Shanghai%2C%20vintage%20noir%20atmosphere%2C%20dramatic%20lighting%2C%20dark%20olive%20green%20tones%2C%20cinematic%20composition&width=600&height=800&seq=drama-cover-11&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=1940s%20Shanghai%20street%20at%20dusk%20with%20vintage%20cars%20and%20old%20buildings%2C%20rainy%20cobblestone%20road%2C%20noir%20cinematography%2C%20moody%20atmospheric%20lighting%2C%20wide%20cinematic%20shot%2C%20historical%20drama&width=1600&height=700&seq=drama-banner-11&orientation=landscape',
    category: 'guochan',
    categories: ['guochan', 'all'],
    year: 2024,
    region: '中国大陆',
    rating: 7.6,
    episodeCount: 40,
    status: '更新中',
    updateInfo: '更新至第24集',
    description: '1941年的上海，各方势力暗流涌动。地下党员顾易中潜入汪伪特务组织，在刀尖上行走。他必须在不被暴露的情况下完成组织交付的任务，同时面对昔日同窗、恋人的误解，孤身奋战在隐蔽战线上。',
    director: '林黎胜',
    cast: ['曾舜晞', '张颂文', '陈都灵', '王玉雯'],
    tags: ['谍战', '悬疑', '年代', '民国', '新剧'],
    episodes: Array.from({ length: 40 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/gu-dou?ep=${i + 1}`,
    })),
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    slug: 'ri-ju-sheng-huo',
    title: '日落时分',
    englishTitle: 'Sunset Vibes',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20poster%20with%20young%20couple%20at%20sunset%20beach%2C%20warm%20golden%20hour%20lighting%2C%20romantic%20and%20nostalgic%20atmosphere%2C%20soft%20pastel%20orange%20and%20pink%20tones%2C%20clean%20minimalist%20composition&width=600&height=800&seq=drama-cover-12&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20coastal%20town%20at%20sunset%20with%20traditional%20houses%2C%20golden%20light%20over%20the%20ocean%2C%20peaceful%20atmosphere%2C%20cinematic%20wide%20landscape%20shot%2C%20warm%20nostalgic%20tones&width=1600&height=700&seq=drama-banner-12&orientation=landscape',
    category: 'riju',
    categories: ['riju', 'all'],
    year: 2024,
    region: '日本',
    rating: 8.2,
    episodeCount: 10,
    status: '已完结',
    updateInfo: '全10集',
    description: '在东京打拼的年轻设计师佐藤夏生因祖母病重回到故乡海边小镇。在那里他遇到了经营小旅馆的青梅竹马，重新审视了自己的人生选择。一段关于故乡、梦想与爱情的温暖治愈故事。',
    director: '石井裕也',
    cast: ['菅田将晖', '有村架纯', '仲野太贺', '黑木华'],
    tags: ['治愈', '爱情', '日剧', '温暖'],
    episodes: Array.from({ length: 10 }, (_, i) => ({
      num: i + 1,
      title: `第${i + 1}集`,
      url: `/detail/ri-ju-sheng-huo?ep=${i + 1}`,
    })),
    isHot: false,
    isNew: false,
    isRecommended: false,
  },
];

export const getDramasByCategory = (categorySlug: string): Drama[] => {
  if (categorySlug === 'all') return dramas;
  return dramas.filter((d) => d.categories.includes(categorySlug));
};

export const getHotDramas = (): Drama[] => dramas.filter((d) => d.isHot);

export const getNewDramas = (): Drama[] => dramas.filter((d) => d.isNew);

export const getRecommendedDramas = (): Drama[] => dramas.filter((d) => d.isRecommended);

export const getDramaBySlug = (slug: string): Drama | undefined =>
  dramas.find((d) => d.slug === slug);